export default __webpack_public_path__ + "static/media/Volte.c72528d3.otf";